/** Path inside the picked folder for a folder upload, the bare name otherwise — two `lease.pdf` stay apart. */
export const fileDisplayPath = (file: File): string => file.webkitRelativePath || file.name
